"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2485],{

/***/ 26110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ usePopularVideos; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15265);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94633);


const usePopularVideos = ()=>{
    const videoApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .VideoApi */ .q();
    const usePopularVideosQuery = (pagination)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "videos",
            "popular",
            pagination
        ], ()=>videoApi.getPopularVideos(pagination), {
            keepPreviousData: true
        });
    return {
        usePopularVideosQuery
    };
};


/***/ }),

/***/ 93715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ StreamProvider; },
  "Q": function() { return /* binding */ useStream; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./utils/loop.ts
var loop = __webpack_require__(58489);
;// CONCATENATED MODULE: ./modules/PopularVideos/PopularVideoSection/Stream.ts

class Stream {
    static fromPlaylist(playlist, timestamp, playlistId) {
        const currentlyPlayingMediaSummary = findMediaAt(playlist || [], timestamp) || {
            item: {
                mediaId: "",
                title: "Loading",
                description: "",
                image: "https://cdn.jwplayer.com/v2/media/jqErKmBL/poster.jpg?width=720",
                duration: 0
            },
            timestamp,
            index: 0
        };
        return new this(currentlyPlayingMediaSummary.timestamp, "https://cdn.jwplayer.com/feeds/".concat(playlistId, ".rss"), currentlyPlayingMediaSummary, (0,loop/* takeNextLooped */.PQ)(playlist || [], currentlyPlayingMediaSummary.item, (media, nextMedia)=>media.mediaId === nextMedia.mediaId, 5));
    }
    constructor(timestamp, streamLink, currentlyPlayingMediaSummary, nextMedia){
        this.timestamp = timestamp;
        this.streamLink = streamLink;
        this.currentlyPlayingMediaSummary = currentlyPlayingMediaSummary;
        this.nextMedia = nextMedia;
    }
}
function findMediaAt(list, timestamp) {
    const completeDuration = list.reduce((acc, item)=>acc + item.duration, 0);
    const normalizedTimestamp = timestamp % completeDuration;
    let composedDuration = 0;
    for (const [index, item] of list.entries()){
        if (normalizedTimestamp < composedDuration + item.duration) return {
            index,
            item,
            timestamp: normalizedTimestamp - composedDuration
        };
        composedDuration += item.duration;
    }
    return undefined;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
// EXTERNAL MODULE: ../../node_modules/.pnpm/usehooks-ts@2.9.1_biqbaboplfbrettd7655fr4n2y/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(49531);
// EXTERNAL MODULE: ../next-utils/src/lib/HttpClient.ts
var HttpClient = __webpack_require__(74552);
;// CONCATENATED MODULE: ./modules/Api/Stream/index.ts

class StreamApi {
    getStreamPlaylist() {
        return this.client.get(this.baseUrl, {}, false);
    }
    constructor(client = new HttpClient/* HttpClient */.e()){
        this.client = client;
        this.baseUrl = "/api/media/stream";
    }
}

// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
;// CONCATENATED MODULE: ./modules/PopularVideos/PopularVideoSection/StreamContext.tsx







const StreamContext = /*#__PURE__*/ react.createContext(null);
const StreamProvider = (param)=>{
    let { children  } = param;
    const stream = useStreamQuery();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamContext.Provider, {
        value: stream,
        children: children
    });
};
function useStreamQuery() {
    const [timestamp, setTimestamp] = (0,react.useState)(new Date().valueOf() / 1000);
    (0,esm/* useInterval */.Yz)(()=>{
        setTimestamp(new Date().valueOf() / 1000);
    }, 5000);
    const { streamPlaylistId  } = (0,ConfigContext/* useConfig */.ZR)();
    const { data: playlist  } = (0,index_production.useQuery)([
        "stream playlist"
    ], ()=>new StreamApi().getStreamPlaylist(), {
        placeholderData: []
    });
    return Stream.fromPlaylist(playlist, timestamp, streamPlaylistId);
}
const useStream = ()=>{
    return (0,react.useContext)(StreamContext);
};


/***/ }),

/***/ 59387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ TvContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Video_VideoCardPlayButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37121);
/* harmony import */ var _PopularVideoSection_StreamContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93715);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59785);





const TvContent = (param)=>{
    let { children , onClick  } = param;
    const stream = (0,_PopularVideoSection_StreamContext__WEBPACK_IMPORTED_MODULE_2__/* .useStream */ .Q)();
    if (!stream) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "max-w-3xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-6 ml-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Video_VideoCardPlayButton__WEBPACK_IMPORTED_MODULE_3__/* .VideoCardPlayButton */ .o, {
                    onClick: onClick,
                    initialVisible: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                variant: "h1",
                className: "line-clamp-3 text-white pb-[3px] mb-2 lg:mb-3",
                children: stream.currentlyPlayingMediaSummary.item.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                variant: "bodyXL",
                className: "line-clamp-3 text-white",
                children: stream.currentlyPlayingMediaSummary.item.description
            }),
            children
        ]
    });
};


/***/ }),

/***/ 3332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TvCover; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _PopularVideoSection_StreamContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93715);
/* harmony import */ var _JWPImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36901);




const TvCover = ()=>{
    const stream = (0,_PopularVideoSection_StreamContext__WEBPACK_IMPORTED_MODULE_2__/* .useStream */ .Q)();
    if (!stream) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "absolute top-0 left-0 w-full h-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JWPImage__WEBPACK_IMPORTED_MODULE_3__/* .JWPImage */ .l, {
                src: stream.currentlyPlayingMediaSummary.item.image,
                alt: stream.currentlyPlayingMediaSummary.item.title,
                size: _JWPImage__WEBPACK_IMPORTED_MODULE_3__/* .JWPImageSize.Background */ .S.Background,
                fill: true,
                style: {
                    objectFit: "cover"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/30 to-black/60"
            })
        ]
    });
};


/***/ }),

/***/ 13646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ TvLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Tv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81806);



const TvLabel = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "uppercase text-white text-sm font-bold mb-4 lg:text-base",
                children: "Parks channel tv"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tv__WEBPACK_IMPORTED_MODULE_2__/* .TvStatus */ .l, {})
        ]
    });
};


/***/ }),

/***/ 81806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TvStatus; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const TvStatus = (param)=>{
    let { icon , color ="white" , text , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("px-4 py-2 rounded-full flex items-center gap-2 text-xs font-medium w-fit", tvStatusBgColor(color), tvStatusTextColor(color), className),
        children: [
            icon ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-[8px] h-[8px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full h-full rounded-full bg-white p-[2px] border border-2 border-red-600 drop-shadow-[0_0_4px_#DC2626] animate-ping opacity-40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-red-600 w-2 h-2 rounded-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: text || "On now"
            })
        ]
    });
};
function tvStatusBgColor(color) {
    switch(color){
        case "red":
            return "bg-red-600";
        default:
            return "bg-white";
    }
}
function tvStatusTextColor(color) {
    switch(color){
        case "red":
            return "text-white";
        default:
            return "text-black";
    }
}


/***/ }),

/***/ 41112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ StreamModal; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(88044);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/CloseIcon/CloseIcon.tsx
var CloseIcon = __webpack_require__(71023);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ./modules/PopularVideos/PopularVideoSection/StreamContext.tsx + 2 modules
var StreamContext = __webpack_require__(93715);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(17361);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
// EXTERNAL MODULE: ./modules/Video/JWPlayerContext.tsx
var JWPlayerContext = __webpack_require__(36762);
// EXTERNAL MODULE: ../../node_modules/.pnpm/usehooks-ts@2.9.1_biqbaboplfbrettd7655fr4n2y/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(49531);
;// CONCATENATED MODULE: ../ui/src/icons/VolumeIcon/VolumeOffFilledIcon.tsx


const VolumeOffFilledIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.383 3.07612C9.56569 3.15186 9.72181 3.28007 9.83163 3.44454C9.94146 3.60901 10 3.80235 10 4.00012V16.0001C9.99996 16.1979 9.94129 16.3912 9.8314 16.5556C9.72152 16.72 9.56535 16.8481 9.38265 16.9238C9.19995 16.9995 8.99892 17.0193 8.80497 16.9807C8.61102 16.9421 8.43285 16.8469 8.293 16.7071L4.586 13.0001H2C1.73478 13.0001 1.48043 12.8948 1.29289 12.7072C1.10536 12.5197 1 12.2653 1 12.0001V8.00012C1 7.7349 1.10536 7.48055 1.29289 7.29301C1.48043 7.10547 1.73478 7.00012 2 7.00012H4.586L8.293 3.29312C8.43285 3.15318 8.61105 3.05787 8.80508 3.01925C8.9991 2.98062 9.20023 3.00041 9.383 3.07612ZM12.293 7.29312C12.4805 7.10565 12.7348 7.00033 13 7.00033C13.2652 7.00033 13.5195 7.10565 13.707 7.29312L15 8.58612L16.293 7.29312C16.3852 7.19761 16.4956 7.12142 16.6176 7.06901C16.7396 7.01661 16.8708 6.98902 17.0036 6.98787C17.1364 6.98671 17.2681 7.01201 17.391 7.06229C17.5138 7.11258 17.6255 7.18683 17.7194 7.28072C17.8133 7.37461 17.8875 7.48627 17.9378 7.60916C17.9881 7.73206 18.0134 7.86374 18.0123 7.99652C18.0111 8.1293 17.9835 8.26052 17.9311 8.38252C17.8787 8.50452 17.8025 8.61487 17.707 8.70712L16.414 10.0001L17.707 11.2931C17.8892 11.4817 17.99 11.7343 17.9877 11.9965C17.9854 12.2587 17.8802 12.5095 17.6948 12.6949C17.5094 12.8803 17.2586 12.9855 16.9964 12.9878C16.7342 12.9901 16.4816 12.8893 16.293 12.7071L15 11.4141L13.707 12.7071C13.5184 12.8893 13.2658 12.9901 13.0036 12.9878C12.7414 12.9855 12.4906 12.8803 12.3052 12.6949C12.1198 12.5095 12.0146 12.2587 12.0123 11.9965C12.01 11.7343 12.1108 11.4817 12.293 11.2931L13.586 10.0001L12.293 8.70712C12.1055 8.51959 12.0002 8.26528 12.0002 8.00012C12.0002 7.73495 12.1055 7.48064 12.293 7.29312Z",
            fill: "currentColor"
        })
    });
};

;// CONCATENATED MODULE: ../ui/src/icons/VolumeIcon/VolumeUpFilledIcon.tsx


const VolumeUpFilledIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.383 3.07602C9.56569 3.15176 9.72181 3.27997 9.83163 3.44444C9.94146 3.60891 10 3.80225 10 4.00002V16C9.99996 16.1978 9.94129 16.3911 9.8314 16.5555C9.72152 16.7199 9.56535 16.848 9.38265 16.9237C9.19995 16.9994 8.99892 17.0192 8.80497 16.9806C8.61102 16.942 8.43285 16.8468 8.293 16.707L4.586 13H2C1.73478 13 1.48043 12.8947 1.29289 12.7071C1.10536 12.5196 1 12.2652 1 12V8.00002C1 7.7348 1.10536 7.48045 1.29289 7.29291C1.48043 7.10537 1.73478 7.00002 2 7.00002H4.586L8.293 3.29302C8.43285 3.15308 8.61105 3.05778 8.80508 3.01915C8.9991 2.98052 9.20023 3.00031 9.383 3.07602ZM14.657 2.92902C14.8445 2.74155 15.0988 2.63623 15.364 2.63623C15.6292 2.63623 15.8835 2.74155 16.071 2.92902C17.0008 3.85667 17.7382 4.95887 18.2409 6.17233C18.7435 7.38578 19.0015 8.68658 19 10C19.0015 11.3135 18.7435 12.6143 18.2409 13.8277C17.7382 15.0412 17.0008 16.1434 16.071 17.071C15.8824 17.2532 15.6298 17.354 15.3676 17.3517C15.1054 17.3494 14.8546 17.2442 14.6692 17.0588C14.4838 16.8734 14.3786 16.6226 14.3763 16.3604C14.374 16.0982 14.4748 15.8456 14.657 15.657C15.4011 14.9151 15.9912 14.0333 16.3933 13.0625C16.7955 12.0916 17.0016 11.0508 17 10C17 7.79002 16.106 5.79202 14.657 4.34302C14.4695 4.15549 14.3642 3.90118 14.3642 3.63602C14.3642 3.37085 14.4695 3.11654 14.657 2.92902ZM11.828 5.75702C11.9209 5.66404 12.0312 5.59028 12.1526 5.53996C12.274 5.48963 12.4041 5.46373 12.5355 5.46373C12.6669 5.46373 12.797 5.48963 12.9184 5.53996C13.0398 5.59028 13.1501 5.66404 13.243 5.75702C13.8009 6.31368 14.2433 6.97508 14.5448 7.70323C14.8463 8.43137 15.001 9.21191 15 10C15.001 10.7881 14.8463 11.5686 14.5447 12.2968C14.2432 13.0249 13.8008 13.6863 13.243 14.243C13.0554 14.4307 12.8009 14.5361 12.5355 14.5361C12.2701 14.5361 12.0156 14.4307 11.828 14.243C11.6404 14.0554 11.5349 13.8009 11.5349 13.5355C11.5349 13.2702 11.6404 13.0157 11.828 12.828C12.2002 12.4572 12.4953 12.0164 12.6965 11.5311C12.8976 11.0457 13.0008 10.5254 13 10C13.0008 9.47463 12.8977 8.95428 12.6965 8.46893C12.4954 7.98357 12.2002 7.54281 11.828 7.17202C11.735 7.07914 11.6613 6.96885 11.6109 6.84746C11.5606 6.72606 11.5347 6.59593 11.5347 6.46452C11.5347 6.3331 11.5606 6.20297 11.6109 6.08158C11.6613 5.96018 11.735 5.84989 11.828 5.75702Z",
            fill: "currentColor"
        })
    });
};

;// CONCATENATED MODULE: ./modules/Video/PlayerControls/VolumeControl/VolumeControl.tsx




const INITIAL_VALUES = {
    isMute: true,
    volume: 90
};
const VolumeControl = (param)=>{
    let { defaultValues , onMute , onVolumeChange  } = param;
    const isFirstRender = (0,esm/* useIsFirstRender */.YZ)();
    const [isMute, setIsMute] = (0,react.useState)((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.isMute) || INITIAL_VALUES.isMute);
    const [volume, setVolume] = (0,react.useState)((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.volume) || INITIAL_VALUES.volume);
    const toggleMute = (0,react.useCallback)(()=>{
        setIsMute((prev)=>!prev);
    }, [
        isMute
    ]);
    const changeVolume = (0,react.useCallback)((e)=>{
        setVolume(e.target.valueAsNumber);
    }, [
        volume
    ]);
    (0,react.useEffect)(()=>{
        if (isFirstRender) return;
        onMute === null || onMute === void 0 ? void 0 : onMute(isMute);
        if (isMute) {
            setVolume(0);
        }
    }, [
        isMute
    ]);
    (0,react.useEffect)(()=>{
        if (isFirstRender) return;
        onVolumeChange === null || onVolumeChange === void 0 ? void 0 : onVolumeChange(volume);
        if (volume !== 0) {
            setIsMute(false);
        } else {
            setIsMute(true);
        }
    }, [
        volume
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative group flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: toggleMute,
                children: isMute ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeOffFilledIcon, {
                    className: "text-neutral-100"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeUpFilledIcon, {
                    className: "text-neutral-100"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "range",
                min: 0,
                max: 100,
                value: volume,
                onChange: changeVolume,
                className: "w-[100px] h-1.5 bg-neutral-100 rounded-none appearance-none cursor-pointer dark:bg-neutral-100"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/Video/StreamModal/StreamPlayer.tsx





const streamPlayerOptions = {
    advertising: {
        autoplayadsmuted: false,
        outstream: false
    },
    aspectratio: "16:9",
    autoPause: {
        viewability: false
    },
    autostart: "viewable",
    controls: false,
    allowFullscreen: true,
    displayHeading: false,
    displaydescription: true,
    displaytitle: true,
    floating: {
        mode: "never"
    },
    generateSEOMetadata: false,
    include_compatibility_script: false,
    intl: {
        en: {}
    },
    logo: {
        hide: true,
        position: "top-right"
    },
    mute: true,
    pipIcon: "disabled",
    playbackRateControls: false,
    preload: "metadata",
    repeat: true,
    width: "100%",
    nextUpDisplay: false
};
const StreamPlayer = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { stream , options , uniquePlayerId  } = param;
    const isInitialPlayerReady = (0,react.useRef)(true);
    const isInitialSeek = (0,react.useRef)(true);
    const jwplayer = (0,JWPlayerContext/* useJWPlayer */.S)();
    const playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!jwplayer || playerRef.current) return;
        playerRef.current = jwplayer(uniquePlayerId).setup({
            playlist: stream.playlist,
            image: stream.thumbnail,
            ...streamPlayerOptions,
            ...options
        });
    }, [
        jwplayer
    ]);
    (0,react.useEffect)(()=>{
        if (!playerRef.current) return;
        playerRef.current.on("ready", ()=>{
            if (!isInitialPlayerReady) return;
            setTimeout(()=>{
                playerRef.current.playlistItem(stream.playlistItemIndex);
                isInitialPlayerReady.current = false;
            }, 0);
        });
        playerRef.current.on("playlistItem", ()=>{
            if (!isInitialSeek) return;
            setTimeout(()=>{
                playerRef.current.seek(stream.timestamp);
                isInitialSeek.current = false;
            }, 0);
        });
    }, [
        stream,
        options,
        jwplayer
    ]);
    const onMute = (0,react.useCallback)((isMute)=>{
        if (!playerRef.current) return;
        playerRef.current.setMute(isMute);
    }, [
        playerRef.current
    ]);
    const onVolumeChange = (0,react.useCallback)((volume)=>{
        if (!playerRef.current) return;
        playerRef.current.setVolume(volume);
    }, [
        playerRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: uniquePlayerId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-2 left-2 text-white md:left-auto md:right-4 md:bottom-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeControl, {
                    onMute: onMute,
                    onVolumeChange: onVolumeChange,
                    defaultValues: {
                        isMute: streamPlayerOptions.mute
                    }
                })
            })
        ]
    });
}, isEqual);
function isEqual(prevProps, nextProps) {
    return lodash_isequal_default()({
        playlist: prevProps.stream.playlist,
        playlistItemIndex: prevProps.stream.playlistItemIndex,
        thumbnail: prevProps.stream.thumbnail
    }, {
        playlist: nextProps.stream.playlist,
        playlistItemIndex: nextProps.stream.playlistItemIndex,
        thumbnail: nextProps.stream.thumbnail
    });
}

;// CONCATENATED MODULE: ./modules/Video/StreamModal/StreamModal.tsx





const StreamModal = (param)=>{
    let { isOpen , setIsOpen  } = param;
    const stream = (0,StreamContext/* useStream */.Q)();
    if (!stream) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        contentClassName: "max-w-6xl !p-0 h-screen lg:h-auto",
        exitButton: (onClose)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {}),
                onClick: onClose,
                size: "sm",
                variant: "base",
                className: "text-neutral-700 text-xs bg-white hover:bg-neutral-50 drop-shadow-sm"
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "h-full relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative bg-gray-300 flex min-h-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamPlayer, {
                        uniquePlayerId: "stream-player",
                        options: {
                            aspectratio: "4:3"
                        },
                        stream: {
                            playlistItemIndex: stream.currentlyPlayingMediaSummary.index,
                            timestamp: stream.timestamp,
                            thumbnail: stream.currentlyPlayingMediaSummary.item.image,
                            playlist: stream.streamLink
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-2 lg:absolute lg:bottom-4 lg:left-4 lg:p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "bodyXL",
                        className: "text-neutral-900 font-bold line-clamp-1 lg:max-w-[500px] lg:text-white",
                        children: stream.currentlyPlayingMediaSummary.item.title
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ InsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const InsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className , id  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-6 w-full max-w-6xl mx-auto", className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ })

}]);